import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export type RoundedBlockProps = {
    $radius?: BorderRadius,
    $bgColor?: COLORS,
    $indent?: string,
}

/**
 * @deprecated use '@r1-frontend/ui-react/experimental/containers/BlockContainer'
 */
const RoundedBlock = styled.div<RoundedBlockProps>`
    display: block;
    border-radius: ${({ $radius = BorderRadius.componentRadius }) => $radius};
    background-color: ${({ $bgColor = COLORS.BgSurface }) => $bgColor};
    padding: ${({ $indent = '16px' }) => $indent};

    @media (min-width: ${wideBreakpoints.mobile}) {
        border-radius: ${({ $radius = BorderRadius.InnerBlockRadius }) => $radius};
        padding: ${({ $indent = '24px' }) => $indent};
    }
`;

export default RoundedBlock;
